module.exports = __webpack_public_path__ + "img/3.3ffb390d.png";